import React from 'react';
import InteractiveGridCanvas from './InteractiveGridCanvas';
import PulseCanvas from './PulseCanvas';

interface CanvasBackgroundLayerProps {
    className?: string;
}

/**
 * Full-screen canvas background layer.
 * Composition of InteractiveGridCanvas and PulseCanvas.
 * 
 * Updates:
 * - Uses isolated components for better maintainability
 * - Implements orange glow accents and heat effects via InteractiveGridCanvas
 * - Implements mixed cool/warm pulses via PulseCanvas
 */
const CanvasBackgroundLayer: React.FC<CanvasBackgroundLayerProps> = ({ className = '' }) => {
    return (
        <div
            className={`absolute inset-0 w-full h-full ${className}`}
            style={{ minHeight: '100%', minWidth: '100%' }}
        >
            {/* Interactive grid with orange glow effects */}
            {/* Boosted intensity for visibility as per user feedback */}
            <InteractiveGridCanvas
                orangeIntensity={1.0}
                orangeRadius={300}
                glowSoftness={0.8}
            />

            {/* Pulse effects (mixed orange/cool) */}
            <PulseCanvas />
        </div>
    );
};

export default CanvasBackgroundLayer;
